.list {
    display: flex;
    flex-direction: column;
    gap: var(--spacer-24);
    list-style: none;
    padding: 0;
    margin: 0;
}
